<template>
  <div>
    <label class="container">
      <span class="description">
        {{ required ? '* ' : '' }}
        <slot></slot>
      </span>
      <input type="checkbox" :value="value" @change="localChecked" />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: () => false },
    label: { type: String, default: () => '' },
    gdprLink: {
      type: String,
      default: () =>
        'https://www.ecpat.se/information-om-hur-ecpat-sverige-behandlar-dina-personuppgifter'
    },
    required: { type: Boolean, default: false }
  },
  methods: {
    localChecked(e) {
      this.$emit('input', e.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 23px;

  text-transform: uppercase;
}

.description {
  display: inline-block;
  padding-top: 1px;
}

.underline {
  text-decoration: underline;
}

a {
  color: #202020;
}

.container {
  cursor: pointer;
  display: block;
  margin-bottom: 12px;
  padding-left: 35px;
  position: relative;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  cursor: pointer;
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  background-color: #fff;
  border-radius: 6px;
  height: 25px;
  left: 0;
  position: absolute;
  top: 0;
  width: 25px;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $green;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark::after {
  content: '';
  display: none;
  position: absolute;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark::after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark::after {
  border: solid #fff;
  border-width: 0 3px 3px 0;
  height: 10px;
  left: 9px;
  top: 5px;
  transform: rotate(45deg);
  width: 5px;
}
</style>
